import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { render, unmount } from 'antd-mobile/es/utils/render';
import { Mask } from 'antd-mobile';
import './index.less';
import { imgUrl } from 'src/utils';
import VideoPlayer, { VideoPlayerRef } from '../VideoPlayer';

interface VideoViewerProps {
  url: string;
  onClose: () => void;
}

interface VideoViewerRef {
  setSubtitle: (subtitleUrl: string, languageCode?: string) => void;
}

const VideoViewer = forwardRef<VideoViewerRef, VideoViewerProps>(({ url, onClose }, ref) => {
  const [visible, setVisible] = React.useState(true);
  const videoPlayerRef = useRef<VideoPlayerRef>(null);

  useImperativeHandle(ref, () => ({
    setSubtitle: (newSubtitleUrl: string, newLanguageCode?: string) => {
      console.log('VideoViewer: 调用setSubtitle');
      if (videoPlayerRef.current) {
        videoPlayerRef.current.setSubtitle(newSubtitleUrl, newLanguageCode);
      }
    }
  }));

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 200);
  };

  return (
    <Mask visible={visible} onMaskClick={handleClose} className="video-custom-mask">
      <div className="video-preview-content">
        <div onClick={handleClose} className='video-mask-close flexMainYcenter'>
          <img src={imgUrl("/ss/app/image/Lingolink/delete07.svg")} width={24} height={24}/>
        </div>
        {/* <video 
          src={imgUrl(url)} 
          crossOrigin="anonymous"
          controls={true}
          controlsList='nodownload noplaybackrate'
          disablePictureInPicture
          autoPlay={true}
          // playsInline={true}
          preload="auto"
          loop={false} 
        /> */}
        <VideoPlayer ref={videoPlayerRef} videoUrl={imgUrl(url, false, false)}
        />
      </div>
    </Mask>
  );
});
VideoViewer.displayName = "VideoViewer";

let currentVideoRef: React.RefObject<VideoViewerRef> | null = null;

const show = (url: string) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const ref = React.createRef<VideoViewerRef>();
  
  const close = () => {
    unmount(container);
    container.remove();
    currentVideoRef = null;
  };

  render(<VideoViewer ref={ref} url={url} onClose={close} />, container);

  currentVideoRef = ref;

  return close;
};

export const updateSubtitle = (newSubtitleUrl: string) => {
  if (currentVideoRef?.current) {
    currentVideoRef.current.setSubtitle(newSubtitleUrl);
  } else {
    console.log('没有活动的视频播放器');
  }
};

export default {
  show,
  updateSubtitle,
};